import { z } from "zod";
import { DbCreateInputOmit, DbUpdate } from "../helpers";
import { OmitStrict } from "../utils";

export const SHORT_PERSISTENT_ID_LENGTH = 8;

export function tryParseShortPersistentId(url = "/") {
  const lastUrlPart = url.split("/").pop() || "";
  const shortPersistentId = lastUrlPart.split("-").pop()?.replaceAll(".html", "") || null;

  return shortPersistentId?.length === SHORT_PERSISTENT_ID_LENGTH ? shortPersistentId : null;
}

export const PublishedDocPage = z.object({
  id: z.string(),
  publishedDocId: z.string(),
  pageShortPersistentId: z.string(),
  pagePersistentId: z.string().optional(),
  pathV1: z.string(),
  pathV2: z.string(),
  storagePath: z.string(),
  locale: z.string().optional(),

  isPrivate: z.boolean(),
  isHidden: z.boolean(),

  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type PublishedDocPage = z.infer<typeof PublishedDocPage>;

export type CreatePublishedDocPage = DbCreateInputOmit<PublishedDocPage> & {
  pagePersistentId: string;
};

export type UpdatePublishedDocPage = DbUpdate<OmitStrict<PublishedDocPage, "pageShortPersistentId" | "publishedDocId">>;
